import { Flag, CircleCheck } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

import type { DecisionCardProps } from '@shared/widget-schemas';
import { cn } from '@/lib/utils';
import { HeroShell, HeroIcon, HeroActionButtons, type WidgetActionProps } from './chat-widget-ui';
import { SkBar, SkBtn, SkCircle } from './skeletons';

export function DecisionCardWidget({
  title,
  description,
  icon,
  variant = 'action',
  accent = 'var(--color-orange-500)',
  actions,
  onAction,
}: DecisionCardProps & WidgetActionProps) {
  const heroVariant = variant === 'go' ? 'default' : 'action';
  const fallback: LucideIcon = variant === 'go' ? CircleCheck : Flag;

  return (
    <HeroShell
      variant={heroVariant}
      accent={accent}
      icon={<HeroIcon name={icon} fallback={fallback} />}
      title={title}
      desc={description}
      actions={actions?.length ? <HeroActionButtons actions={actions} onAction={onAction} /> : undefined}
    />
  );
}

export function DecisionCardSkeleton({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        'glass-card flex w-full max-w-[min(560px,100%)] flex-col gap-[18px] px-[26px] py-6',
        className,
      )}
    >
      <div className="flex items-start gap-4">
        <SkCircle size="48px" radius="14px" />
        <div className="flex flex-1 flex-col gap-2">
          <SkBar width="72%" height="16px" />
          <SkBar width="96%" height="9px" />
          <SkBar width="88%" height="9px" />
        </div>
      </div>
      <div className="flex justify-end gap-2.5">
        <SkBtn width="120px" />
        <SkBtn width="150px" />
      </div>
    </div>
  );
}
